module.exports = __webpack_public_path__ + "static/media/home-jingxuanrencaiku.fbe9aa0b.png";